import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import PeopleIcon from '@mui/icons-material/People';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import { useAppSelector } from '../../app/hooks';
import Box from '@mui/material/Box';
import './mainNavigation.css';
import { Button, Divider, Tooltip } from '@mui/material';
import { USER_TYPES, getHelpURL } from '../../services/user';
import { BusinessOutlined, HelpOutline, WifiProtectedSetupOutlined } from '@mui/icons-material';

function MainNavItemButton(
  href: string,
  pathName: string,
  displayName: string,
  Icon: any,
) {
  return (
    <Link className='mainNav' to={href} title={pathName}>
      <ListItemButton selected={pathName == href}>
        <ListItemIcon>
          <Icon sx={{ color: 'white' }} />
        </ListItemIcon>
        <ListItemText primary={displayName} sx={{ color: 'white' }} />
      </ListItemButton>
    </Link>
  );
}

function SubNavItemButton(
  href: string,
  pathName: string,
  displayName: string,
  Icon?: any,
) {
  return (
    <Link className='subNav' to={href} title={pathName}>
      <ListItemButton selected={pathName == href}>
        {Icon && <ListItemIcon>
          <Icon sx={{ color: 'white' }} />
        </ListItemIcon>}
        <ListItemText primary={displayName} sx={{ color: 'white', pl: 3 }} />
      </ListItemButton>
    </Link>
  );
}

function QuestionnaireSubMenu() {
  const location = useLocation();
  return (
    <React.Fragment>
      {MainNavItemButton('/questionnaires', location.pathname, 'Questionnaires', DynamicFormIcon)}
    </React.Fragment>
  );
}

// NOTE: nav items are set to `#` until their components are built.
function VendorNavListItems(props: { open?:boolean }) {
  const { open } = props;
  const { user } = useAppSelector(state => state.user);
  const location = useLocation();

  // Paid/published status now arrives in real time over the WebSocket company channel and is
  // patched into state.user.companies by userSlice — the old 30s getUserFromAuthSession poll
  // that watched companies[0].isPublished has been removed.

  return (
    <React.Fragment>{user?.type && <>
      {user.type === USER_TYPES.CONTENT_OWNER && user.companies.length > 0 && user.companies[0].isPublished && MainNavItemButton('/dashboard', location.pathname, 'Dashboard', SpeedOutlinedIcon)}
      {open && <Box className={user?.type !== USER_TYPES.CONTENT_OWNER ? `topNav ${location.pathname.indexOf('profile') > -1 ? 'active' : ''}` : ''}>
        {MainNavItemButton('/profile', location.pathname, 'Profile', AccountCircleOutlinedIcon)}
        {user.type === USER_TYPES.VENDOR_ADMIN && <>
          {SubNavItemButton('/profile/services', location.pathname, 'Services')}
          {SubNavItemButton('/profile/sites', location.pathname, 'Sites')}
          {SubNavItemButton('/profile/applications', location.pathname, 'Applications')}
          {SubNavItemButton('/profile/certifications', location.pathname, 'Certifications')}
        </>}
        {(user.type === USER_TYPES.VENDOR_ADMIN || user.type === USER_TYPES.ASSESSOR) && SubNavItemButton('/profile/assessments', location.pathname, 'Manage Assessments')}
        {user.type !== USER_TYPES.CONTENT_OWNER && SubNavItemButton('/profile/documents', location.pathname, 'Documents')}
      </Box>}
      {!open && MainNavItemButton('/profile', location.pathname, 'Profile', AccountCircleOutlinedIcon)}
      {MainNavItemButton('/registry', location.pathname, 'Companies', BusinessOutlined)}
      {MainNavItemButton('/applications', location.pathname, 'Applications', AssessmentOutlinedIcon)}
      { (user.type === USER_TYPES.VENDOR_ADMIN || user.type === USER_TYPES.TPN_ADMIN) && (
        MainNavItemButton('/trusted-partner-exchange', location.pathname, 'TPN Exchange', WifiProtectedSetupOutlined)
      )}
      {MainNavItemButton('/partner-resources', location.pathname, 'Partner Resources', LocalLibraryIcon)}
    </>}</React.Fragment>
  );
}

function TPNAdminNavListItems() {
  const location = useLocation();
  return (
    <React.Fragment>
      {MainNavItemButton('/dashboard', location.pathname, 'Dashboard', SpeedOutlinedIcon)}
      {MainNavItemButton('/admin/users', location.pathname, 'Admin', PeopleIcon)}
      {QuestionnaireSubMenu()}
      {MainNavItemButton('/registry', location.pathname, 'Companies', BusinessOutlined)}
      {MainNavItemButton('/applications', location.pathname, 'Applications', AssessmentOutlinedIcon)}
      {MainNavItemButton('/trusted-partner-exchange', location.pathname, 'TPN Exchange', WifiProtectedSetupOutlined)}
      {MainNavItemButton('/partner-resources', location.pathname, 'Partner Resources', LocalLibraryIcon)}
    </React.Fragment>
  );
}

export function MainListItems(props: { open?: boolean }) {
  const { user } = useAppSelector(state => state.user);

  return (
    <React.Fragment>
      {user?.type && <>
        {user?.type == USER_TYPES.TPN_ADMIN ? <TPNAdminNavListItems /> : <VendorNavListItems open={props.open} />}
        <Divider sx={{ mt: 2, mb: 2, borderColor: 'rgba(255,255,255,.4)' }} />
        <Box sx={{ textAlign: 'center' }}><Tooltip title='Need Support?'><a target="_blank" href={getHelpURL(user?.type)} rel="noreferrer"><Button fullWidth variant='contained' onClick={()=> { return false; }}><HelpOutline sx={{ mr: props.open ? 1 : 0 }} />{props.open && 'Need Support?'}</Button></a></Tooltip></Box>
        <Box sx={{ textAlign: 'center', mt: 1 }}><Tooltip title='TPN QRGs'><a target="_blank" href="https://www.ttpn.org/links-resources/" rel="noreferrer"><Button fullWidth variant='contained' onClick={()=> { return false; }}><HelpOutline sx={{ mr: props.open ? 1 : 0 }} />{props.open && 'TPN How-To Guides'}</Button></a></Tooltip></Box>
      </>}
    </React.Fragment>
  );
}
